import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { keyCardsData } from 'sections/Resources/DemurrageAndDetention/data';
import { KeyCardType } from 'sections/Resources/DemurrageAndDetention/types';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionKey01/SectionKey01.module.scss';

const cn = classNames.bind(styles);

const SectionKey01 = (): ReactElement => {
  const cardItems = keyCardsData.map((card: KeyCardType) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-container')}>
            <div className={cn('card__heading-icon')}>
              <img
                src='/images/pages/Resources/DemurrageAndDetention/icon-file.svg'
                alt='file icon'
              />
            </div>
            <h3 className={cn('card__heading')}>{card.heading}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('key-01')}>
      <div className={cn('container')}>

        <h2 className={cn('key-01__heading')}>
          Key Components of the OSRA 22 Final Rule 2024
        </h2>

        <div className={cn('key-01__cards')}>
          {cardItems}
        </div>

      </div>
    </section>
  );
};

export default SectionKey01;